export default {
  // eslint-disable-next-line no-undef
  apiUrl: process.env.REACT_APP_API_URL,
  mobileApiUrl: process.env.REACT_APP_MOBILE_API_URL,
  providersUrl: process.env.REACT_APP_PROVIDERS_URL,
  growthbookUrl: process.env.REACT_APP_GROWTHBOOK,
};
